export const LangFr = {
    name: 'fr',
    data: {
        "sidebar": {
            'dashboard': 'Tableau de bord',
            "profil": "Mon profil",
            'search': 'Recherche de missions',
            'file': 'Mes documents',
            'mission': 'Mes missions',
            'help': 'Aide'
        },
        'profil': {
            'profil': 'Mon profil',
            'account': 'Mon compte',
            'knowledge': 'Mon savoir faire',
            'proof': 'Mes justificatifs',
            'availabilities': 'Mes disponibilités',
            'training_guides': 'Formations & Guides',
            'params': 'Paramètres'
        },
        'savoir': {
            "cv": 'Curriculum Vitae',
            'exp': 'Expériences',
            'skills': 'Compétences',
            'lang': 'Langue',
            'tools': 'Matériels possédés'
        },
        'proof': {
            'identity': 'Justificatif d’identité',
            'degree': 'Formations',
            'licence': 'Permis',
            'otherDocuments': 'Autres Documents'
        },
        'availabilities': {
            'myhours':'Mes horaires',
            'dispo':'Périodes de disponibilité',
            'subtitleH':'Indiquez à quelles tranches horaires vous êtes disponible' +
                ' pour travailler.',
            'subtitleD':'Indiquez les périodes où vous n\'êtes pas du tout disponible.'

        },
        'training_guides': {
            'welcome_guide': 'Guide de bienvenue',
            'safety_booklet': 'Livret de sécurité',
            'health_guide': 'Guide intérimaire santé'
        },
        'justify':{
            'm_vitale_title_c':'Ajouter une carte vitale',
            'm_vitale_title_u':'Modifier la carte vitale',
            'm_vitale_title_d':'Supprimer une carte vitale',
            'm_vitale_d_content':'Êtes-vous sûr de vouloir supprimer votre carte' +
                ' vitale ? Cette action est irréversible.',
            'm_iban_title_c':'Ajouter une identité bancaire',
            'm_iban_title_u':'Modifier l\'identité bancaire',
            'm_iban_title_d':'Supprimer une identité bancaire',
            'm_identity_title_c':'Validation d’identité',
            'm_proof_title_c':'Ajouter un justificatif de domicile',
        },
        'pdf_view': {
            'not_found': 'Ce document est introuvable. Il n\'a peut-être pas été envoyé, ou a été supprimé.',
            'error': 'Le document n\'a pas pu être chargé. Réessayez dans quelques instants.',
            'retry': 'Réessayer',
        },
        'residencePermit': {
            'title': "Titre de séjour",
            'valid_until': "Valable jusqu'au {date}",
            'expires_on': "Expire le {date}",
            'expired_on': "Expiré le {date}",
            'end_unknown': "Date de fin non renseignée",
            'document_types': {
                'new_permit': "Nouveau titre de séjour",
                'receipt': "Récépissé de renouvellement",
                'anef_extension': "Attestation de prolongation d'instruction (ANEF)",
            },
            'document_status': {
                'pending': "En cours de vérification",
                'validated_until': "Validé jusqu'au {date}",
                'validated': "Validé",
                'refused_with_reason': "Refusé : {reason}",
                'refused': "Refusé",
            },
            'add_extension': "Ajouter ma prolongation",
            'banner_expiring_title': "Votre titre de séjour expire bientôt",
            'banner_expiring_text': "Ajoutez sa prolongation pour continuer à recevoir des missions.",
            'banner_expired_title': "Titre de séjour expiré",
            'banner_expired_text': "Ajoutez sa prolongation : aucune mission ne peut vous être confiée en attendant.",
            'extension_modal': {
                'choice_title': "Prolongation du titre de séjour",
                'choice_subtitle': "Quel document avez-vous reçu ?",
                'choice_consent': "En sélectionnant un document, vous autorisez nos partenaires à vérifier votre identité et acceptez notre politique de confidentialité.",
                'options': {
                    'new_permit': {
                        'title': "Nouveau titre de séjour",
                        'subtitle': "Carte de séjour ou visa renouvelé, recto et verso",
                        'import_button': "Importer le titre de séjour",
                    },
                    'receipt': {
                        'title': "Récépissé de renouvellement",
                        'subtitle': "Remis par la préfecture pendant l'examen de votre demande",
                        'import_button': "Importer le récépissé",
                    },
                    'anef_extension': {
                        'title': "Attestation de prolongation d'instruction",
                        'subtitle': "Téléchargée sur le site de l'ANEF",
                        'import_button': "Importer l'attestation",
                    },
                },
                'conditions_intro': "Assurez-vous que le document respecte ces conditions :",
                'conditions': {
                    'readable_title': "Lisible",
                    'readable_text': "Sans flou ni reflet : chaque information se lit.",
                    'whole_title': "Tout le document est visible",
                    'whole_text': "Les quatre coins apparaissent, rien n'est coupé ni caché.",
                    'end_date_title': "Date de fin lisible",
                    'end_date_text': "La date jusqu'à laquelle il est valable apparaît.",
                },
                'file_front': "Recto",
                'file_back': "Verso",
                'file_single': "Document",
                'back': "Retour",
                'analysing': "Envoi du document en cours…",
                'success': "Justificatif envoyé : il est en cours de vérification.",
                'errors': {
                    'VISA_COMPLEMENTARY_PENDING': "Un justificatif est déjà en cours de vérification : attendez sa réponse avant d'en ajouter un autre.",
                    'RESIDENCE_PERMIT_MISSING': "Ajoutez d'abord votre titre de séjour avant sa prolongation.",
                    'VISA_COMPLEMENTARY_FILE_MISSING': "Il manque un fichier : importez chaque face demandée.",
                    'default': "Une erreur est survenue. Réessayez dans quelques instants.",
                },
            },
        },
        'mission': {
            'tasks_title': 'Tâches du ',
            'tasks_title_elided': 'Tâches de l\'',
            'tool_provider_company': 'Fourni par l\'entreprise',
            'tool_provider_temp_worker': 'À apporter par vous',
            'dress_code_title': 'Tenue vestimentaire',
        },
        'signature': {
            'loading_title': "Préparation de votre contrat",
            'loading_text': "Il s’ouvre dans un instant.",
        },
        'endOfMissionDocuments': {
            'title': "Documents de fin de mission",
            'subtitle': "Certificats de travail, attestations France Travail",
            'all_missions': "Toutes vos missions",
            'types': {
                'work_certificate': "Certificat de travail",
                'france_travail_certificate': "Attestation France Travail",
            },
            'received_on': {
                'work_certificate': "Reçu le {date}",
                'france_travail_certificate': "Reçue le {date}",
            },
            'pending_tag': "En préparation",
            'pending_hint': "Avec la fiche de paie de {month}",
            'pending_hint_elided': "Avec la fiche de paie d’{month}",
            'pending_modal_title': "Votre attestation France Travail arrive début {month}",
            'pending_modal_text': "Elle est établie avec votre fiche de paie de {month}.",
            'pending_modal_text_elided': "Elle est établie avec votre fiche de paie d’{month}.",
            'pending_modal_close': "J’ai compris",
            'months': ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        }

    }
}